export default __webpack_public_path__ + "static/media/logomarcaHeader-white.6d44662b.png";